angular.module('mercury.modules.reports.reconciliations')
.controller('ReportsReconciliationTenderDetailsCtrl', ["$filter", "PosTenders", "reporttime", "$scope", "$stateParams", "title", function($filter, PosTenders, reporttime, $scope, $stateParams, title) {
  $scope.tenderCols = [
    {label: 'Time', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Amount', type: 'number', key: 'tenderAmount', filter: 'currency'}
  ];

  $scope.loading = PosTenders.getByIntervalForTenderType(reporttime.start(), reporttime.end(), reporttime.interval(), $stateParams.id);

  $scope.loading.then(function(results) {
    title.set(results[0].tenderName + ' Detail Report');

    $scope.tenders = results;

    angular.forEach($scope.tenders, function(period) {
      period.percent = (period.periodTotal !== 0) ? (period.tenderAmount / period.periodTotal) * 100 : 0;
    });

    var total = $filter('sumof')($scope.tenders, 'periodTotal');
    $scope.totalPercent = total !== 0 ? ($filter('sumof')($scope.tenders, 'tenderAmount') / total) * 100 : 0;
  });
}]);
